module.exports = __webpack_public_path__ + "img/image (1).9d54e63e.jpg";